import { render, staticRenderFns } from "./CardTarjaEnqueteTrocaDePassesSportv.vue?vue&type=template&id=5af2df98&scoped=true"
import script from "./CardTarjaEnqueteTrocaDePassesSportv.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTrocaDePassesSportv.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTrocaDePassesSportv.vue?vue&type=style&index=0&id=5af2df98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2df98",
  null
  
)

export default component.exports